import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDevice } from '../../../constants/device/device';
import ITrackShipmentResults from '../../../interfaces/trackShipment/trackShipmentResults';
import {
	ShipmentInfoItem,
	ShipmentInfoLabel,
	ShipmentInfoValue,
	ShipmentInfoWrapper,
} from './trackShipmentResult.styles';

interface Props {
	shipmentInfo: ITrackShipmentResults;
}

const TrackShipmentResultInfo: FC<Props> = ({ shipmentInfo }) => {
	const { t } = useTranslation('trackShipment');
	const { smallDevice } = useDevice();

	return (
		<ShipmentInfoWrapper>
			{shipmentInfo.estimatedDeliveryDateMessage && (
				<ShipmentInfoItem>
					<ShipmentInfoLabel>{`${t('estimated-delivery')}:`}</ShipmentInfoLabel>
					<ShipmentInfoValue>{shipmentInfo.estimatedDeliveryDateMessage}</ShipmentInfoValue>
				</ShipmentInfoItem>
			)}
			<ShipmentInfoItem>
				<ShipmentInfoLabel>{`${t('tracking-number')}:`}</ShipmentInfoLabel>
				<ShipmentInfoValue>
					{shipmentInfo.labelId ? shipmentInfo.labelId : shipmentInfo.trackingNumber}
				</ShipmentInfoValue>
			</ShipmentInfoItem>
			{shipmentInfo.serviceName && shipmentInfo.serviceName.length > 0 && (
				<ShipmentInfoItem>
					<ShipmentInfoLabel>{`${t('type')}:`}</ShipmentInfoLabel>
					<ShipmentInfoValue>{shipmentInfo.serviceName}</ShipmentInfoValue>
				</ShipmentInfoItem>
			)}
			{smallDevice && (
				<ShipmentInfoItem>
					<ShipmentInfoLabel>{`${t('status')}:`}</ShipmentInfoLabel>
					<ShipmentInfoValue>{shipmentInfo.status.statusText}</ShipmentInfoValue>
				</ShipmentInfoItem>
			)}
			{shipmentInfo.custDeclNumber && shipmentInfo.custDeclNumber.length > 0 && (
				<ShipmentInfoItem>
					<ShipmentInfoLabel>{`${t('custNumber')}:`}</ShipmentInfoLabel>
					<ShipmentInfoValue>{shipmentInfo.custDeclNumber}</ShipmentInfoValue>
				</ShipmentInfoItem>
			)}
			{shipmentInfo.weight && shipmentInfo.weight.length > 0 && (
				<ShipmentInfoItem>
					<ShipmentInfoLabel>{`${t('weight')}:`}</ShipmentInfoLabel>
					<ShipmentInfoValue>{shipmentInfo.weight}</ShipmentInfoValue>
				</ShipmentInfoItem>
			)}
		</ShipmentInfoWrapper>
	);
};

export default TrackShipmentResultInfo;
